<div class="collapseStyle"  (click)="selectedCollapse()">
    <img [ngClass]="{'rotate180':!rotateImg}" class="downArrow" src="../../../../assets/images/down-arrow.png" alt="">
    <span class="collapseText"> 
        {{entry.groupName === 'undefined'?'No grouping':'Grouping'+' '+ entry.groupName}}  {{entry.length}} rows 
    </span>
</div>
 